import { Folder } from '@opengov/bnp-component-folders/src';
import { IFolder } from '@opengov/reporting-types';

export const ROOT_FOLDER: Folder = {
  id: 'none',
  title: 'All Reports',
  parentFolderId: null
};

export function convertFolders(folders: IFolder[]): Folder[] {
  return folders.map((folder) => ({
    id: `${folder.id}`,
    title: folder.title,
    parentFolderId: folder.parentFolderId ? `${folder.parentFolderId}` : ROOT_FOLDER.id,
    subfolders: folder.subfolders && convertFolders(folder.subfolders)
  }));
}

export const getRootFolder = (folders: IFolder[]) => {
  return {
    ...ROOT_FOLDER,
    subfolders: convertFolders(folders)
  };
};

export const findFolderById = (folders: IFolder[], folderId: string): IFolder | null => {
  for (const folder of folders) {
    if (`${folder.id}` === folderId) {
      return folder;
    }
    const subfolder = findFolderById(folder.subfolders || [], folderId);
    if (subfolder) {
      return subfolder;
    }
  }
  return null;
};

export function getFolderListExpandedItemsKey(entitySubdomain: string) {
  return `${entitySubdomain}_reports_folder_list_expanded_items`;
}
